<script setup lang="ts">
type InputType = 'text' | 'number' | 'date' | 'password' | 'textarea';
type Direction = 'row' | 'column';
const { label, type, direction, disabled, rows = '8' } = defineProps<{
    label?: string;
    type: InputType,
    direction?: Direction,
    disabled?: boolean,
    rows?: string,
}>();
const modelValue = defineModel<string | Date | number>('modelValue');

const id = `input_${Math.random().toString(36).substring(2, 15)}`;

</script>
<template>
    <div class="flex flex-col gap-1" :class="{ 'flex-row': direction === 'row' }">
        <label v-if="label" class="py-1 mr-1">{{ label }}</label>
        <textarea v-if="type === 'textarea'" :type="type" :value="typeof modelValue === 'string' ? modelValue : ''" :rows="rows"
            @input="modelValue = ($event.target as HTMLInputElement).value" :disabled="disabled"
            class="bg-slate-100 text-slate-800 rounded-sm p-1 border-1 border-slate-400"
            :class="{ 'bg-slate-200': disabled }" />
        <input v-else :type="type" :value="modelValue" @input="modelValue = ($event.target as HTMLInputElement).value"
            :disabled="disabled" class="bg-slate-100 text-slate-800 rounded-sm p-1 border-1 border-slate-400"
            :class="{ 'bg-slate-200': disabled }" />
    </div>
</template>
